import React, { useState } from 'react'
import { Container, Row, Form,  Dropdown, ButtonGroup } from 'react-bootstrap';

import axios from 'axios';

export const CareerForm = () => {

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [submitted, setSubmitted] = useState(false);

    // First name
    const [firstName, setFirstName] = useState('');
    const [firstNameerror, setFirstnamerror] = useState(null);

    const validateFirstName = (name) => {
        if (!name) {
        return 'First name is required';
        }
        if (!/^[a-zA-Z]+$/.test(name)) {
        return 'First name should contain only letters';
        }
        return null;
    };

    const handleFirstNameChange = (event) => {
        const raw = event.target.value;
        const name = raw.slice(0, 55);
        setFirstName(name);
        const error = validateFirstName(name);
        setFirstnamerror(error);
    };

    // Last Name
    const [lastName, setLastName] = useState('');
    const [lastNameerror, setLastnameerror] = useState(null);
    const handleLastNameChange = (event) => {
        const raw = event.target.value;
        const name = raw.slice(0, 55);
        setLastName(name);
        const error = validateLastName(name);
        setLastnameerror(error);
    };
    const validateLastName = (name) => {
        if (!name) {
          return 'Last name is required';
        }
        if (!/^[a-zA-Z]+$/.test(name)) {
          return 'Last name should contain only letters';
        }
        return null;
    };


    // Email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Email
    const [error, setError] = useState(null);
    const [email, setEmail] = useState('');
    const handleEmailChange = (event) => {
        const emailValue = event.target.value;
        if (emailRegex.test(emailValue)) {
          setError(null);
        } else {
          setError('Invalid email address');
        }
        setEmail(emailValue);
    };

    // Phone Number
    const [contact, setContact] = useState('');
    const [isValid, setIsValid] = useState(false);

    const handleContactChange = (event) => {
        const phoneNumber = event.target.value;
    
        if (/^\d*$/.test(phoneNumber)) {
          setContact(phoneNumber);
    
            // Regular expression to match exactly 10 digits
            const regex = /^\d{10}$/;

            if (phoneNumber.length === 0 || regex.test(phoneNumber)) {
            const validationMessage = phoneNumber.length === 10 ? 'Mobile number is valid.' : '';
            setIsValid(validationMessage);
            
            // Hide the validation message after 3 seconds
            if (validationMessage) {
                setTimeout(() => {
                    setIsValid('');
                }, 3000);
            }
          } else {
            setIsValid('Mobile number must be exactly 10 digits.');
    
          }
        } else {
            setIsValid('Only digits are allowed.');
            
        }
    };


    const [mr, setMr] = useState('-None-')

    const [num, setNumr] = useState('-None-')
    
    // Experience Year
    const [experienceInYear, setExperienceInYear] = useState('');

    const [gender, setGender] = useState('');

    const [currentEmployer, setCurrentEmployer] = useState('');
    

    const [noticePeriod, setNoticePeriod] = useState('');

    const [currentLocation, setCurrentLocation] = useState('');
    
    const [yearOfGraduation, setYearOfGraduation] = useState('');
    const [Yearerror, setYearError] = useState('');

    // Role
    const [role, setRole] = useState('');

    const handleYearOfGraduationChange = (event) => {
        let inputYear = event.target.value;

        // Remove any non-digit characters
        inputYear = inputYear.replace(/\D/g, '');

        // Limit length to 4 digits
        if (inputYear.length > 4) {
            inputYear = inputYear.slice(0, 4);
        }

        // Negative check (shouldn't happen since we strip non-digits)
        if (inputYear && Number(inputYear) < 0) {
            setYearError('Year cannot be negative');
        } else {
            setYearError('');
        }

        setYearOfGraduation(inputYear);
    };


    // Current CTC
    const [currentCTC, setCurrentCTC] = useState('');
    const [ctcError, setCtcError] = useState('');
    const handleCurrentCTCChange = (event) => {
        const value = event.target.value;
        if(value < 0){
            setCtcError('CTC cannot be a negative number');
        }else{
            setCtcError('');
            setCurrentCTC(value)
        }
    };

    // Expect CTC
    const [expectingCTC, setExpectingCTC] = useState('');
    const [expectError, setExpectError] = useState('');
    const handleExpectingCTCChange = (event) => {
        const value = event.target.value;
        if(value < 0){
            setExpectError('Expect CTC cannot be a negative number');
        }else{
            setExpectError('');
            setExpectingCTC(value)
        }
    };


    
    const [howDidYouComeAcrossThisVacancy, setHowDidYouComeAcrossThisVacancy] = useState('');

    const handleCurrentEmployerChange = event => {
        const emplimit = event.target.value.slice(0, 55);
        setCurrentEmployer(emplimit);
    };

    const handleCurrentLocationChange = (event) => {
        setCurrentLocation(event.target.value);
    };


    // Resume Upload start
    const [resume, setResume] = useState(null);
    const [resumeError, setResumeError] = useState('')
    const [isDragging, setIsDragging] = useState(false);

    const handleResumeChange = (event) => {
        const file = event.target.files[0];
        validateFile(file);
    };
    
    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer.files[0];
        console.log(file)
        console.log(resume)


        // New Code
        if (file) {
            validateFile(file); // validate before setting
        }

        setIsDragging(false); // Reset the dragging state
    };

    const handleDragOver = (event) => {
        event.preventDefault(); // Prevent default behavior
    };

    const handleDragEnter = () => {
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleClearFile = () => {
        setResume(null); // Clear the file state
        setResumeError("");
        document.getElementById("resume").value = ""; // Clear the input field
    };

    const validateFile = (file) => {
        // Reset error state first
        setResumeError("");
        
        if (!file) {
            setResumeError("No file selected.");
            return;
        }

        const allowedTypes = [
            "application/pdf", 
            "application/msword", 
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
            "application/rtf", 
            "application/vnd.oasis.opendocument.text"
        ];
        const maxSize = 5 * 1024 * 1024; // 2MB max size
        
        if (!allowedTypes.includes(file.type)) {
            setResumeError("Invalid file type. Only PDF, DOC, DOCX, RTF, and ODT files are allowed.");
            return;
        }

        if (file.size > maxSize) {
            setResumeError("File size exceeds 5MB.");
            return;
        }

        setResume(file);
        return (true)
    };
    // Resume Upload End


    // Skill Set
    const [tags, setTags] = useState([]);
    const [skillSet, setSkillSet] = useState('');

    const handleSkillSetChange = e => setSkillSet(e.target.value);

    const handleKeyDown = e => {
        if ((e.key === 'Enter' || e.key === ',') && skillSet.trim()) {
        e.preventDefault();
        const newTag = skillSet.trim();
        if (!tags.includes(newTag)) {
            setTags([...tags, newTag]);
        }
        setSkillSet('');
        }
    };

    const removeTag = indexToRemove =>
    setTags(tags.filter((_, i) => i !== indexToRemove));


    const handleSubmit =  async (event) => {
        event.preventDefault();
        setSubmitted(true);


        // check mr / num
        if (mr === '-None-') {
            setErrorMessage('Title is required');
            return;
        }
        if (num === '-None-') {
            // this depends—if +91 is your default and okay, skip this
            // But if you want them to explicitly choose, compare to a default like '-Select-'
            setErrorMessage('Country code is required');
            return;
        }

        if (!role) {
            setErrorMessage('Role is required');
            return;
        }

        // Validate required fields

        if (!firstName || !lastName || !email || !yearOfGraduation || !gender || !experienceInYear || !currentEmployer ||
            !currentCTC || ctcError || !expectingCTC || expectError || !howDidYouComeAcrossThisVacancy ||
            !tags.length || !noticePeriod ||
            !currentLocation || !/^\d{10}$/.test(contact) || !role ||
            !mr || !num || !validateFile(resume)
        ) {
        setErrorMessage('All fields are Required');
        return;
        }


        // API Validation Start
        const formData = new FormData();
        formData.append('title', mr);
        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
        formData.append('email', email);
        formData.append('countryCode', num);
        formData.append('contact', contact);
        formData.append('yearOfGraduation', yearOfGraduation);
        formData.append('gender', gender);
        formData.append('currentEmployer', currentEmployer);
        formData.append('experienceInYear', experienceInYear);
        formData.append('role', role);
        formData.append('currentCTC', currentCTC);
        formData.append('expectingCTC', expectingCTC);
        formData.append('tags', JSON.stringify(tags));
        formData.append('noticePeriod', noticePeriod);
        formData.append('howDidYouComeAcrossThisVacancy', howDidYouComeAcrossThisVacancy);
        formData.append('currentLocation', currentLocation);
        formData.append('resume', resume);

        try {
            const response = await axios.post(
                'http://10.20.20.123:8001/api/career',
                formData
            );



            console.log('Submitted form data:', {
                title: mr,
                firstName,
                lastName,
                email,
                countryCode: num,
                contact,
                yearOfGraduation,
                gender,
                currentEmployer,
                experienceInYear,
                role,
                currentCTC,
                expectingCTC,
                tags,
                noticePeriod,
                howDidYouComeAcrossThisVacancy,
                currentLocation,
                resume: resume?.name || null,
            });

        

            // Clear any previous error messages
            setErrorMessage('');
            setSubmitted(false);
            setSuccessMessage(response.data.message || 'Form submitted successfully!');

            // Clear form fields
            setFirstName('');
            setLastName('');
            setEmail('');
            setYearOfGraduation('');
            setExperienceInYear('');
            setCurrentCTC('');
            setSkillSet('');
            setTags([]);
            setHowDidYouComeAcrossThisVacancy('');
            setRole('');
            setContact('');
            setNumr('-None-');
            setGender('');
            setCurrentEmployer('');
            setExpectingCTC('');
            setNoticePeriod('');
            setCurrentLocation('');
            setMr('-None-');
            setResume(null);
            setResumeError('');

            // Optionally, clear the success message after a few seconds
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        }catch (err) {
            console.error(err);
            setErrorMessage(err.response?.data?.message || 'Submission failed');
        } finally {
            setSubmitted(false);
        }
    };
    // API Validation End



    // Dropdown Options
    const countryCodes = ['+91', '+93', '+92', '+96'];
    const mrOptions = ['Mr', 'Ms', 'Mrs'];
    const genderOptions = ['Male', 'Female', 'Other'];
    const expOptions = ['Fresher','0-1 years','2-3 years','3-4 years','4-5 years','5-6 years','6+ years'];
    const noticeOptions = ['Immediate','Not Applicable','1 month','2 months','3 months'];
    const foundOptions = ['Newspaper AD','Instagram','LinkedIn','Facebook','Referral','Career Page'];
    const roleOptions = ['Saas Developer','Front End Developer','UI / UX Designer','Android Developer','Back End Developer'];       
    
    

  return (
    <>

        {/* Career Form Banner */}
        <section className='about-page'>
            <div className='about-bg'>
                <div className='c-detail-shap-1 con-shap-c'>
                    <img src="../assets/images/whi-5.svg" alt="" />
                </div>
                <div className='about-shap-3'>
                    <img src="../assets/images/about-shap-1.png" alt="" />
                </div>
                <div className='about-shap-4'>
                    <img src="../assets/images/about-shap-2.png" alt="" />
                </div>
                <div className='about-shap-5 con-shap-c'>
                    <img src="../assets/images/about-shap-3.svg" alt="" />
                </div>
                <div className='career-shap-2'>
                    <img src="../assets/images/whi-3.svg" alt="" />
                </div>
                <Container>
                    <Row className='align-items-center'>
                        <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                            <div className='career-img text-center'>
                                <img src="../assets/images/carrer-form-banner.png" alt="" />
                            </div>
                            <div className='career-shap-1'>
                                <img src="../assets/images/white-arr.svg" alt="" />
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                            <div className='tech-content'>
                                <h2>Shape Your Future With Us </h2>
                                <p>Discover a place where your skills meet opportunity. At IMUII, we’re always on the lookout for passionate professionals ready to make an impact. Share your details with us and let’s build something meaningful together. Your future starts here. </p>
                                
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </section>

        <section className='form-padding'>
            <Container>
                <form onSubmit={handleSubmit}>
                    <Row className='align-items-center mb-lg-4 mb-1'>
                        <div className="col-lg-6">
                            <div className='from-text'>
                                <h3>Apply for this opportunity</h3>
                                <p>Upload your Resume</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className='form-margin'>
                                <label htmlFor="your-cv" className="w-100" >
                                    <div className={`cv_filelabel ${isDragging ? 'dragging' : ''}`}
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop}
                                    onDragEnter={handleDragEnter}
                                    onDragLeave={handleDragLeave}>
                                        <div className="form-group file text-center mb-0">
                                            <label className="custom-file-upload" htmlFor="resume">
                                                <span className="upload-text">
                                                    {resume ? resume.name : "Upload your Resume"}
                                                </span>
                                                {!resume && (
                                                    <span> or Drag and drop it here
                                                        <p className="help-info">Only .doc, .docx, .pdf, .odt, .rtf</p>
                                                    </span>
                                                    
                                                )}
                                            </label>
                                            
                                            <input type="file" placeholder='hello' id="resume" className="form-control  your-cv file-input" onChange={handleResumeChange} accept=".doc,.docx,.pdf,.odt,.rtf" />

                                            {resume && (
                                                <button type="button" onClick={handleClearFile} className="clear-btn">
                                                    x
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </label>
                                {resumeError && <div style={{ color: '#BC1823', fontSize: '14px' , marginTop: '5px' }}>{resumeError}</div>}
                            </div>
                        </div>
                    </Row>
                    <Row className='job-apply-form'>
                        <div className='froms-text'>
                            <h3>Personal Details</h3>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-right">
                                <label htmlFor="firstName" className="label-text mb-2">First Name<span className='required'>*</span></label><br />
                                <div className="d-flex">
                                    

                                    <Dropdown className='width-20 career-drop-small' as={ButtonGroup}>
                                        <Dropdown.Toggle variant="white" className={`form-control text-start `}>
                                            {mr || "-None-"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {mrOptions.map(opt => (
                                            <Dropdown.Item key={opt} onClick={() => setMr(opt)}>{opt}</Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>


                                    <input type="text" maxLength={55} pattern="[A-Za-z]+" id="firstName" className="form-control" value={firstName} onChange={handleFirstNameChange} required placeholder="Enter Your First Name" />
                                </div>

                                {submitted && mr === '-None-' && (
                                    <div style={{ color: '#BC1823', fontSize: '14px', marginTop: '5px' }}>
                                        Title is required
                                    </div>
                                )}
                                
                                {firstNameerror && <div style={{ color: '#BC1823', fontSize: '14px' , marginTop: '5px' }}>{firstNameerror}</div>}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-left">
                                <label htmlFor="lastName" className="label-text mb-2">Last Name<span className='required'>*</span></label><br/>
                                <input type="text" id="lastName"  maxLength={55} pattern="[A-Za-z]+" required className="form-control" value={lastName} onChange={handleLastNameChange} placeholder="Enter Your Last Name" />

                                {lastNameerror && <div style={{ color: '#BC1823', fontSize: '14px', marginTop: '5px' }}>{lastNameerror}</div>}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-right">
                                <label htmlFor="email" className="label-text mb-2">Email Address<span className='required'>*</span></label>

                                <input type="email" id="email" className="form-control" required value={email} onChange={handleEmailChange} placeholder="Enter Your Email Address" />
                                {error && <div style={{ color: '#BC1823', fontSize: '14px', marginTop: '5px' }}>{error}</div>}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-left">
                                <label htmlFor="contact" className="label-text mb-2">Contact<span className='required'>*</span></label>
                                <div className="d-flex">
                                    

                                    <Dropdown className='width-20 career-drop-small' as={ButtonGroup}>
                                        <Dropdown.Toggle variant="white" className="form-control text-start">
                                        {num}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                        {countryCodes.map(c => (
                                            <Dropdown.Item key={c} onClick={() => setNumr(c)}>{c}</Dropdown.Item>
                                        ))}
                                        </Dropdown.Menu>
                                    </Dropdown>


                                    <input type="tel"  id="contact" className="form-control" required value={contact} onChange={handleContactChange} placeholder="Enter Your Contact Number" />
                                </div>


                                {submitted && num === '-None-' && (
                                    <div style={{ color: '#BC1823', fontSize: '14px', marginTop: '5px' }}>
                                        Country code is required
                                    </div>
                                )}
                                {isValid && (<div style={{ color: isValid === 'Mobile number is valid.' ? 'green' : '#BC1823',fontSize: '14px', marginTop: '5px' }}>{isValid}</div>)}
                            </div>
                        </div>

                        <div className='col-lg-6'>
                            <div className='form-margin-right'>
                                <div className='row'>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="yearOfGraduation" className="label-text mb-2">Year Of Graduation<span className='required'>*</span></label>
                                            <input type="number" id="yearOfGraduation" className="form-control"  required value={yearOfGraduation} onChange={handleYearOfGraduationChange} placeholder="Enter Your Graduation Year" />

                                            {Yearerror && <div style={{ color: '#BC1823', marginTop: '8px' }}>{Yearerror}</div>}
                                        </div>
                                        
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="gender" className="label-text mb-2">Gender<span className='required'>*</span></label>
                                            

                                            <Dropdown as={ButtonGroup} className='career-drop-width'>
                                                <Dropdown.Toggle variant="white" className={`form-control text-start`}>
                                                    {gender || "-Select Your Gender-"}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {genderOptions.map(opt => (
                                                    <Dropdown.Item key={opt} onClick={() => setGender(opt)}>{opt}</Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {submitted && !gender && (
                                                <Form.Text className="text-danger">Gender is required</Form.Text>
                                            )}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="form-group form-margin-left">
                                <label htmlFor="currentEmployer" className="label-text mb-2">Current Employer<span className='required'>*</span></label>
                                <input type="text" id="currentEmployer" maxLength={55} className="form-control" required value={currentEmployer} onChange={handleCurrentEmployerChange} placeholder="Enter Your Current Company Name" />
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="form-group form-margin-right">
                                <label htmlFor="experienceInYear" className="label-text mb-2">Experience In Year<span className='required'>*</span></label>
                                

                                <Dropdown as={ButtonGroup}  className='career-drop-width'>
                                    <Dropdown.Toggle
                                        variant="white"
                                        className={`form-control text-start `}
                                    >
                                        {experienceInYear || '-Select Your Exp Yrs-'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {expOptions.map(opt => (
                                        <Dropdown.Item key={opt} onClick={() => setExperienceInYear(opt)}>
                                            {opt}
                                        </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {submitted && !experienceInYear && (
                                    <Form.Text className="text-danger">Experience is required</Form.Text>
                                )}

                            </div>
                            
                        </div>

                        <div className="col-lg-6">
                            <div className="form-group form-margin-left">
                                <label htmlFor="role" className="label-text mb-2">
                                Role<span className='required'>*</span>
                                </label>
                                <Dropdown as={ButtonGroup} className='career-drop-width'>
                                <Dropdown.Toggle variant="white" className="form-control text-start">
                                    {role || '-Select Your Role-'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {roleOptions.map(opt => (
                                    <Dropdown.Item key={opt} onClick={() => setRole(opt)}>
                                        {opt}
                                    </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                                </Dropdown>
                                {submitted && !role && (
                                <Form.Text className="text-danger">Role is required</Form.Text>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="form-group form-margin-right">
                                <label htmlFor="currentCTC" className="label-text mb-2">Current CTC (In Lakhs Per Annum)<span className='required'>*</span></label>
                                <input type="number" id="currentCTC" className="form-control" required value={currentCTC} onChange={handleCurrentCTCChange} placeholder="Enter Current CTC" />

                                {ctcError && <div style={{ color: '#BC1823', marginTop: '8px' }}>{ctcError}</div>}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-left">
                                <label htmlFor="expectingCTC" className="label-text mb-2">Expecting CTC (In Lakhs Per Annum)<span className='required'>*</span></label>
                                <input type="number" id="expectingCTC" className="form-control" required value={expectingCTC} onChange={handleExpectingCTCChange} placeholder="Enter Expecting CTC" />

                                {expectError && <div style={{ color: '#BC1823', marginTop: '8px' }}>{expectError}</div>}
                            </div>
                        </div>
                        <div className="col-lg-6">

                            <div className="form-group form-margin-right">
                                <label htmlFor="skillSet" className="label-text mb-2">Skill Set<span className='required'>*</span></label>
                                <div className="skill-input-container">
                                    {tags.map((tag, idx) => (
                                        <span className="tag" key={tag}>
                                        {tag}
                                        <button
                                            type="button"
                                            className="tag-remove"
                                            onClick={() => removeTag(idx)}
                                        >
                                            ×
                                        </button>
                                        </span>
                                    ))}
                                    <input
                                        type="text"
                                        value={skillSet}
                                        onChange={handleSkillSetChange}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Enter the Skill Set"
                                        className="skill-input"
                                    />
                                </div>

                                {submitted && !tags.length && (
                                    <Form.Text className="text-danger">At least one skill is required</Form.Text>
                                )}

                                
                            </div>


                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-left">
                                <label htmlFor="noticePeriod" className="label-text mb-2">Notice Period<span className='required'>*</span></label>
                                

                                <Dropdown as={ButtonGroup} className='career-drop-width'>
                                    <Dropdown.Toggle
                                        variant="white"
                                        className={`form-control text-start `}
                                    >
                                        {noticePeriod || '-Select Your Notice Period-'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {noticeOptions.map(opt => (
                                        <Dropdown.Item key={opt} onClick={() => setNoticePeriod(opt)}>
                                            {opt}
                                        </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {submitted && !noticePeriod && (
                                    <Form.Text className="text-danger">Notice period is required</Form.Text>
                                )}


                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-right">
                                <label htmlFor="howDidYouComeAcrossThisVacancy" className="label-text mb-2">How Did You Come Across This Vacancy?<span className='required'>*</span></label>
                                

                                <Dropdown as={ButtonGroup} className='career-drop-width'>
                                    <Dropdown.Toggle
                                        variant="white"
                                        className={`form-control text-start `}
                                    >
                                        {howDidYouComeAcrossThisVacancy || '-None-'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {foundOptions.map(found => (
                                        <Dropdown.Item key={found} onClick={() => setHowDidYouComeAcrossThisVacancy(found)}>
                                            {found}
                                        </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {submitted && !howDidYouComeAcrossThisVacancy && (
                                    <Form.Text className="text-danger">Please select a source</Form.Text>
                                )}


                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group form-margin-left">
                                <label htmlFor="currentLocation" className="label-text mb-2">Current Location<span className='required'>*</span></label>
                                <input type="text" id="currentLocation" className="form-control" required value={currentLocation} onChange={handleCurrentLocationChange} placeholder="Enter Your Current Location" />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div>
                                <button type="submit" className="apply-btn">APPLY</button>
                            </div>
                        </div>
                    </Row>
                </form>

                {errorMessage && <div style={{ color: 'white', marginTop: '10px', backgroundColor: 'red', padding: '10px 15px', borderRadius: '5px', fontSize: '14px' }}>{errorMessage}</div>}
                {successMessage && <div style={{ color: 'white', marginTop: '10px', backgroundColor: 'green', padding: '10px 15px', borderRadius: '5px', fontSize: '14px' }}>{successMessage}</div>}

            </Container>
            
        </section>
    
    </>
  )
}
